// ============================================================
// UrbanWear -- AdminLayout con link a MercadoPago
// ============================================================
import { Outlet, Link, useLocation, Navigate, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store'
import styles from './AdminLayout.module.css'
import BrandLogo from '@/components/shared/BrandLogo'

const NAV = [
  { to: '/admin',            icon: 'ti-dashboard',        label: 'Dashboard'   },
  { to: '/admin/pedidos',    icon: 'ti-shopping-cart',    label: 'Pedidos'     },
  { to: '/admin/productos',  icon: 'ti-shirt',            label: 'Productos'   },
  { to: '/admin/inventario', icon: 'ti-package',          label: 'Inventario'  },
  { to: '/admin/pagos',      icon: 'ti-credit-card',      label: 'Pagos MP'    },
  { to: '/admin/contenido', icon: 'ti-brush', label: 'Contenido' },
  { to: '/admin/seguridad',  icon: 'ti-shield-lock',      label: 'Seguridad'   },
  { to: 'usuarios', icon: 'ti-users', label: 'Usuarios' },
  { to: '/admin/reportes', icon: 'ti-chart-bar', label: 'Reportes' },
  { to: '/admin/importar', icon: 'ti-upload', label: 'Importar' }
]

export default function AdminLayout() {
  const user    = useAuthStore(s => s.user)
  const logout  = useAuthStore(s => s.logout)
  const isAdmin = useAuthStore(s => s.isAdmin)
  const loc     = useLocation()
  const nav     = useNavigate()

  if (!user || !isAdmin()) return <Navigate to="/login" replace />

  const handleLogout = () => { logout(); nav('/login') }

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <div className={styles.sidebarTop}>
          <Link to="/" className={styles.logo}>
			<BrandLogo variant="image" />
		  </Link>
          <nav className={styles.nav}>
            {NAV.map(item => (
              <Link key={item.to} to={item.to}
                className={`${styles.navItem} ${loc.pathname === item.to || (item.to !== '/admin' && loc.pathname.startsWith(item.to)) ? styles.navItemActive : ''}`}>
                <i className={`ti ${item.icon}`}/>
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className={styles.sidebarUser}>
          <div className={styles.avatar}>{user.fullName.charAt(0).toUpperCase()}</div>
          <div style={{ flex:1, minWidth:0 }}>
            <div className={styles.userName}>{user.fullName}</div>
            <div className={styles.userRole}>{user.role}</div>
          </div>
          <button onClick={handleLogout} title="Cerrar sesion"
            style={{ background:'transparent', border:'none', cursor:'pointer',
              color:'var(--white)', fontSize:18, padding:4, display:'flex',
              alignItems:'center', flexShrink:0, transition:'color .15s' }}
            onMouseEnter={e => (e.currentTarget.style.color = 'var(--accent)')}
            onMouseLeave={e => (e.currentTarget.style.color = 'var(--white)')}>
            <i className="ti ti-logout"/>
          </button>
        </div>
      </aside>

      <main className={styles.main}>
        <div className={styles.topbar}>
          <div className={styles.pageLabel}>
            {NAV.find(n => n.to === loc.pathname || (n.to !== '/admin' && loc.pathname.startsWith(n.to)))?.label ?? 'Admin'}
          </div>
          <a href="/" target="_blank" className={styles.viewStore}>
            <i className="ti ti-external-link"/> Ver tienda
          </a>
        </div>
        <div className={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  )
}
